import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Isotipo from "@/components/Isotipo";

const mont = { fontFamily: "Montserrat, sans-serif" };

// Short animated logo reveal: isotipo + GRABARTE + "20 años · desde 2007".
const IntroSplash = ({ theme, onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2800);
    return () => clearTimeout(t);
  }, [onDone]);

  const letters = "GRABARTE".split("");

  return (
    <motion.div
      data-testid="intro-splash"
      className="fixed inset-0 z-[120] flex flex-col items-center justify-center cursor-pointer"
      style={{ backgroundColor: theme.bg }}
      exit={{ opacity: 0, transition: { duration: 0.6 } }}
      onClick={onDone}
    >
      <motion.div
        initial={{ scale: 0.4, opacity: 0, rotate: -12 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <Isotipo className="w-16 h-16 md:w-20 md:h-20" fill={theme.accent} />
      </motion.div>

      <div className="mt-6 flex overflow-hidden">
        {letters.map((l, i) => (
          <motion.span
            key={i}
            className="text-3xl md:text-5xl font-extrabold tracking-tight"
            style={{ ...mont, color: theme.text }}
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 + i * 0.05, ease: [0.22, 1, 0.36, 1] }}
          >
            {l}
          </motion.span>
        ))}
      </div>

      <motion.div
        className="mt-6 h-px"
        style={{ backgroundColor: theme.accent }}
        initial={{ width: 0 }}
        animate={{ width: 160 }}
        transition={{ duration: 0.8, delay: 1.1, ease: [0.22, 1, 0.36, 1] }}
      />

      <motion.p
        className="mt-6 text-[11px] md:text-xs uppercase tracking-[0.35em] text-center"
        style={{ ...mont, color: theme.sub }}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 1.4 }}
      >
        20 años de experiencia · desde 2007
      </motion.p>
    </motion.div>
  );
};

export default IntroSplash;
